import { generateQr } from "@/utils";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const BusinessQr = () => {
  const { id: businessId } = useParams();
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState("");
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const res = await generateQr(businessId);
        console.log({ res });
        const redirectUrl = res?.data?.redirect_url;
        setLoading(false);
        window.location.href = redirectUrl;
      } catch (error) {
        setIsError("some error occurred");
        setLoading(false);

        console.error("some error occurred", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
        }}
      >
        <div style={{ fontSize: 22, fontWeight: 500, marginBottom: 8 }}>
          Please wait...
        </div>
        <div
          style={{
            width: 40,
            height: 40,
            border: "4px solid #eee",
            borderTop: "4px solid #3498db",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  if (isError)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          color: "#e74c3c",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 500, marginBottom: 8 }}>
          Something went wrong
        </div>
        <div style={{ fontSize: 16 }}>{isError}</div>
      </div>
    );
  return (
    <div
  className="flex flex-col items-center justify-center h-[60vh]"
>
  <div className="flex items-center space-x-3">
    <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin" />
    <span className="text-2xl font-semibold text-gray-800">Loading...</span>
  </div>
  <div className="text-base text-gray-500 mt-2">Please wait....</div>
</div>
  );
};

export default BusinessQr;
